import React from 'react'
import Section1 from '../ComponentsPage/AboutUs/Section1'
import Section2 from '../ComponentsPage/AboutUs/Section2'
import About from '../ComponentsPage/Banner/About'
const AboutUs = () => {
  return (
    <div>
      <About/>
      <Section1/>
      <Section2/>
    </div>
  )
}

export default AboutUs
